import { motion } from "framer-motion";
import { MapPin, Phone, EnvelopeSimple } from "@phosphor-icons/react";

export default function ContactSection({ t }) {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32"
      style={{ background: "#0A0F1A" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-sm uppercase tracking-[0.2em] text-[#00F0FF] font-semibold mb-4 block font-chivo">
            {t.contact.overline}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-white font-outfit">
            {t.contact.title}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Contact details */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5 }}
            className="flex flex-col gap-8"
          >
            <a
              href={`tel:${t.contact.phone.replace(/\s/g, "")}`}
              data-testid="contact-phone"
              className="flex items-center gap-5 group"
            >
              <div className="w-14 h-14 rounded-2xl bg-white/[0.04] border border-white/10 flex items-center justify-center group-hover:border-[#00F0FF]/40 transition-colors">
                <Phone size={26} weight="duotone" className="text-[#00F0FF]" />
              </div>
              <div>
                <p className="text-xs text-[#94A3B8] font-chivo mb-1 uppercase tracking-wider">
                  {t.contact.phone === "+386 5 393 9011" ? "Phone" : "Telefon"}
                </p>
                <p className="text-white font-outfit font-medium text-lg group-hover:text-[#00F0FF] transition-colors">
                  {t.contact.phone}
                </p>
              </div>
            </a>

            <a
              href={`mailto:${t.contact.email}`}
              data-testid="contact-email"
              className="flex items-center gap-5 group"
            >
              <div className="w-14 h-14 rounded-2xl bg-white/[0.04] border border-white/10 flex items-center justify-center group-hover:border-[#00F0FF]/40 transition-colors">
                <EnvelopeSimple size={26} weight="duotone" className="text-[#00F0FF]" />
              </div>
              <div>
                <p className="text-xs text-[#94A3B8] font-chivo mb-1 uppercase tracking-wider">Email</p>
                <p className="text-white font-outfit font-medium text-lg group-hover:text-[#00F0FF] transition-colors">
                  {t.contact.email}
                </p>
              </div>
            </a>

            <div className="flex items-center gap-5" data-testid="contact-address">
              <div className="w-14 h-14 rounded-2xl bg-white/[0.04] border border-white/10 flex items-center justify-center flex-shrink-0">
                <MapPin size={26} weight="duotone" className="text-[#00F0FF]" />
              </div>
              <div>
                <p className="text-xs text-[#94A3B8] font-chivo mb-1 uppercase tracking-wider">
                  {t.contact.address.includes("Slovenija") ? "Naslov" : "Address"}
                </p>
                <p className="text-white font-outfit font-medium text-lg">
                  {t.contact.address}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Google Maps */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="rounded-2xl overflow-hidden border border-white/10"
            data-testid="contact-map"
          >
            <iframe
              title="ETRADE Location"
              src="https://maps.google.com/maps?q=Stjenkova+ulica+51,+Sempeter+pri+Gorici,+Slovenia&t=&z=15&ie=UTF8&iwloc=&output=embed"
              className="w-full aspect-video"
              style={{ filter: "invert(90%) hue-rotate(180deg) contrast(80%)" }}
              loading="lazy"
              allowFullScreen
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
